import { useOffers } from "@nju/data-access-portal-offers";
import { MobileOfferDetails } from "@nju/feature-portal-offers";
import { Icon } from "@nju/icons";
import {
  A,
  BlockText,
  Drawer,
  Heading,
  Panel,
  Separator,
  Text,
  useOverlay,
} from "@nju/ui";

export function MobileBanner() {
  const drawer = useOverlay();
  const { mobile } = useOffers();
  const { indefiniteOffers } = mobile;
  const offer = indefiniteOffers.find((offer) => {
    return offer.display;
  });

  return (
    <>
      {drawer.isOpened && offer && (
        <Drawer onClose={drawer.close}>
          <MobileOfferDetails offer={offer} />
        </Drawer>
      )}
      <Panel
        badge={{
          body: "5G",
          variant: "dark",
        }}
        forceShowTitleBlock={true}
        invisibleSeparator={true}
        separatorSize="none"
        testId="mobile-offer-banner"
      >
        <Icon
          className="mr-3 w-6 h-6 from-tablet:w-8 from-tablet:h-8"
          name="mobile-android"
          tone="accent"
        />
        <Separator
          size={{
            "@onlyMobile": "s",
            "@fromDesktop": "xs",
          }}
          tone="invisible"
        />
        <Heading font="ttfirs" tone="neutral" variant="h4" weight="bold">
          nju subskrypcja
        </Heading>
        {offer && (
          <BlockText className="mt-1" size="l">
            od {offer.totalRecurringPrice} zł/mies.
          </BlockText>
        )}
        <Separator size="m" tone="invisible" />
        <A
          className="items-center gap-3"
          display="inlineFlex"
          onClick={drawer.open}
          size="inline"
          variant="simple"
        >
          <Text tone="accent">sprawdź</Text>
          <Icon height={18} name="arrow-right" tone="accent" width={18} />
        </A>
      </Panel>
    </>
  );
}
